import React, { useState, useEffect, useRef } from "react";
import AtlasMenu from "./AtlasMenu";
import ContactPopup from "./ContactPopup";
import "./LogoBlanc.css";

function isInsideAtlas(clientX, clientY) {
  const x = clientX / window.innerWidth;
  const y = clientY / window.innerHeight;
  return x <= 0.33 - 0.165 * y;
}

function isInsideContact(clientX, clientY) {
  const x = clientX / window.innerWidth;
  const y = clientY / window.innerHeight;
  if (y < 0.20 || y > 0.85) return false;
  const t = (y - 0.20) / (0.85 - 0.20);
  const left  = 0.295 + (0.189 - 0.295) * t;
  const right = 0.755 + (0.649 - 0.755) * t;
  return x >= left && x <= right;
}

const LogoBlanc = () => {
  const [menuOpen,    setMenuOpen]    = useState(false);
  const [contactOpen, setContactOpen] = useState(false);

  // Refs pour accéder aux états courants dans le listener sans le recréer
  const menuOpenRef    = useRef(menuOpen);
  const contactOpenRef = useRef(contactOpen);
  useEffect(() => { menuOpenRef.current    = menuOpen;    }, [menuOpen]);
  useEffect(() => { contactOpenRef.current = contactOpen; }, [contactOpen]);

  // Listener posé une seule fois, pour toujours
  useEffect(() => {
    const handleClick = (e) => {
      if (!menuOpenRef.current && !contactOpenRef.current) return;
      if (e.target.closest?.('.logoblanc-link')) return;
      if (isInsideAtlas(e.clientX, e.clientY)) return;
      if (contactOpenRef.current && isInsideContact(e.clientX, e.clientY)) return;
      setMenuOpen(false);
      setContactOpen(false);
    };

    const handleKey = (e) => {
      if (e.key === 'Escape') {
        setMenuOpen(false);
        setContactOpen(false);
      }
    };

    window.addEventListener('click', handleClick);
    window.addEventListener('keydown', handleKey);
    return () => {
      window.removeEventListener('click', handleClick);
      window.removeEventListener('keydown', handleKey);
    };
  }, []); // tableau vide — posé une seule fois au montage

  return (
    <>
      <div
        className={`logoblanc-link ${menuOpen ? "menu-open" : ""}`}
        onClick={() => setMenuOpen(prev => !prev)}
        role="button"
        aria-label="Menu"
      >
        <div className="logoblanc">
          <img src="/media/logo/LogoBlanc2.png" alt="" className="logoblanc-lettres" />
          <img src="/media/logo/LogoBlanc1.png" alt="Elise Voët" className="logoblanc-symboles" />
        </div>
      </div>

      <AtlasMenu
        isOpen={menuOpen}
        onClose={() => setMenuOpen(false)}
        onContactOpen={() => setContactOpen(prev => !prev)}
      />

      <ContactPopup
        isOpen={contactOpen}
        onClose={() => setContactOpen(false)}
      />
    </>
  );
};

export default LogoBlanc;